import React from 'react';
import SurveysStadisticsUI from './components/SurveysStadisticsUI';

const Main = () => {
    return (
        <SurveysStadisticsUI/>
    );
};

export default Main;